import React, { useLayoutEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import PageSeo from "@/components/PageSeo";
import { publicLocaleFromPath, resolvePublicSeo } from "@/lib/publicSeo";
import { setLocale } from "@/i18n";
import { useLocale } from "@/i18n/useLocale";

export default function RouteSeo() {
  const { pathname } = useLocation();
  const locale = useLocale();
  const seo = useMemo(() => resolvePublicSeo(pathname, locale), [locale, pathname]);
  const routeLocale = publicLocaleFromPath(pathname);
  useLayoutEffect(() => { if (routeLocale) setLocale(routeLocale); }, [routeLocale]);
  return <PageSeo {...seo} />;
}
